import { AreaChart, Area, XAxis, YAxis, Tooltip } from 'recharts';
import DashboardCard, {
  ChartBody,
  ChartPlot,
  ChartTooltip,
  chartTick,
  CHART_MARGIN,
} from '../../dashboard/components/DashboardCard';
import type { AdminDashboardStats } from '../../../domain/superadmin/types';

export function ChurnEvolutionSection({ churn }: { churn: AdminDashboardStats['churnEvolution'] }) {
  const data = churn.series.map((s) => ({ name: s.month, rate: s.rate }));

  return (
    <section className="mb-s5">
      <DashboardCard title="Evolução de churn">
        <p className="mb-s3 text-[12px] text-muted">
          % de clientes perdidos no período · aproximação (sem histórico Stripe completo)
        </p>
        <ul className="mb-s4 grid grid-cols-1 gap-s2 sm:grid-cols-3">
          <li className="rounded-xl border border-error/30 bg-danger-bg/40 px-s4 py-s3">
            <p className="text-[10px] font-semibold uppercase tracking-[0.07em] text-danger-text">Atual</p>
            <p className="font-mono text-[22px] font-semibold tabular-nums text-default">
              {churn.currentRate.toFixed(1)}%
            </p>
          </li>
          <li className="rounded-xl border border-border px-s4 py-s3">
            <p className="text-[10px] font-semibold uppercase tracking-[0.07em] text-muted">Média</p>
            <p className="font-mono text-[22px] font-semibold tabular-nums text-default">
              {churn.avgRate.toFixed(1)}%
            </p>
          </li>
          <li className="rounded-xl border border-border px-s4 py-s3">
            <p className="text-[10px] font-semibold uppercase tracking-[0.07em] text-muted">Perdidos</p>
            <p className="font-mono text-[22px] font-semibold tabular-nums text-default">
              {churn.lostCount} contas
            </p>
          </li>
        </ul>
        <ChartBody>
          <ChartPlot>
            <AreaChart data={data} margin={CHART_MARGIN}>
              <XAxis dataKey="name" tick={chartTick} tickLine={false} axisLine={false} />
              <YAxis unit="%" tick={chartTick} tickLine={false} axisLine={false} width={40} />
              <Tooltip content={<ChartTooltip formatValue={(v) => `${v}%`} />} />
              <Area
                type="monotone"
                dataKey="rate"
                name="Churn %"
                stroke="var(--color-error)"
                fill="var(--color-error)"
                fillOpacity={0.15}
              />
            </AreaChart>
          </ChartPlot>
        </ChartBody>
      </DashboardCard>
    </section>
  );
}
